export enum Schedule {
    CONTROLLED_DRUG = 'CONTROLLED_DRUG',
    ETHICAL_DRUG = 'ETHICAL_DRUG',
    NARCOTIC = 'NARCOTIC',
    NPN = 'NPN',
    HOMEOPATHIC = 'HOMEOPATHIC',
    OTC = 'OTC',
    CATEGORY_IV = 'CATEGORY_IV',
    PRECURSOR = 'PRECURSOR',
    PRESCRIPTION = 'PRESCRIPTION',
    SCHEDULE_C_RADIOPHARMACEUTICALS = 'SCHEDULE_C_RADIOPHARMACEUTICALS',
    SCHEDULE_D_BIOLOGIC_VACCINE = 'SCHEDULE_D_BIOLOGIC_VACCINE',
}

export const ScheduleLabels: Record<Schedule, string> = {
    [Schedule.CONTROLLED_DRUG]: 'Controlled Drug',
    [Schedule.ETHICAL_DRUG]: 'Ethical Drug',
    [Schedule.NARCOTIC]: 'Narcotic',
    [Schedule.NPN]: 'NPN',
    [Schedule.HOMEOPATHIC]: 'Homeopathic',
    [Schedule.OTC]: 'OTC',
    [Schedule.CATEGORY_IV]: 'Category IV',
    [Schedule.PRECURSOR]: 'Precursor',
    [Schedule.PRESCRIPTION]: 'Prescription',
    [Schedule.SCHEDULE_C_RADIOPHARMACEUTICALS]: 'Schedule C \u2013 Radiopharmaceuticals',
    [Schedule.SCHEDULE_D_BIOLOGIC_VACCINE]: 'Schedule D \u2013 Biologic/Vaccine',
};

export function getScheduleLabel(value: string | null | undefined): string {
    if (!value) return '';
    return ScheduleLabels[value as Schedule] || value;
}
